import useAuthStore from "../../../../stores/useAuthStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useCartStore from "../../../../stores/useCartStore";
import useTransactionStore from "../../../../stores/useTransactionStore";
import { enrichLineItemFields } from "../utils/taxCalculations";

export const flatDiscount = async (
  product,
  pricingRule,
  setCart,
  cart,
  orderType,
  cartObj,
  iscoupon,
  couponInput,
  uniqReferenceId,
  mPricingCouponId,
  mPricingRulesId,
  removeDiscounts
) => {
  const isExchange = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
  const saleTypeValidation = pricingRule?.cwrSaletypeId === null || orderType === undefined ? true : pricingRule?.cwrSaletypeId === orderType?.cwrSaletype?.cwrSaletypeId;
  let hasChanges = false;
  const tillData = useAuthStore.getState().tillData;
  const saleTypeData = usePOSConfigStore.getState().saleTypeData || {};
  let taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
  // Iterate through each item in the cart
  cartObj.items.map((item) => {
    let excludingFlag = true;

    // Check if there are any changes
    const matchingCategory = pricingRule.mPricingPcategories.find((pc) => pc.mProductCategoryId === item.mProductCategoryId);
    if (
      (pricingRule.excludeProductCategories === "Y" && matchingCategory) ||
      (pricingRule.excludeProductCategories !== "Y" && !matchingCategory && pricingRule.mPricingPcategories.length > 0) ||
      (pricingRule.excludeProductCategories === "N" && pricingRule.mPricingPcategories.length === 0)
    ) {
      excludingFlag = false;
    }

    const matchingBrand = pricingRule.mPricingBrands.find((pc) => pc.mBrandId === item.productBrandId);
    if (
      (pricingRule.excludeBrands === "Y" && matchingBrand) ||
      (pricingRule.excludeBrands !== "Y" && !matchingBrand && pricingRule.mPricingBrands.length > 0) ||
      (pricingRule.excludeBrands === "N" && pricingRule.mPricingBrands.length === 0)
    ) {
      excludingFlag = false;
    }

    const matchingProductIndex = pricingRule.mPricingXProducts.findIndex((op) => op.mProductId === item.productId);
    if (
      (pricingRule.excludeProducts === "Y" && matchingProductIndex !== -1) ||
      (pricingRule.excludeProducts !== "Y" && matchingProductIndex === -1 && pricingRule.mPricingXProducts.length > 0) ||
      (pricingRule.excludeProducts === "N" && pricingRule.mPricingXProducts.length === 0)
    ) {
      excludingFlag = false;
    }

    let pricingRuleFlag = true;

    // Apply additional logic for pricingRuleFlag based on your requirements

    if (item.discount <= 0) {
      delete item.priority;
    }

    if (
      saleTypeValidation &&
      excludingFlag &&
      pricingRuleFlag &&
      (product.productId === item.productId || iscoupon || removeDiscounts) &&
      (item?.priority ? item?.priority < pricingRule.priority : true)
    ) {
      const index = cartObj.items.findIndex((p) => p.productId === item.productId && p.upc === item.upc && p.mBatchId === item.mBatchId);
      pricingRule.minimumQty = pricingRule.minimumQty ? pricingRule.minimumQty : 0;

      if (index >= 0) {
        // G3: xQty > 1 makes the flat amount apply per bundle ("₹50 off every 3"), e.g. qty 7 with
        // xQty 3 gets 2 × ₹50. A rule with no xQty (or xQty 1) keeps the per-unit behaviour.
        const bundleSize = Number(pricingRule.xQty) > 1 ? Number(pricingRule.xQty) : null;
        const lineQty = Math.abs(cartObj.items[index].weight);
        if (lineQty >= pricingRule.minimumQty && (bundleSize === null || lineQty >= bundleSize)) {
          const prcPrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
          const weight = cartObj.items[index].weight;
          const taxRate = cartObj.items[index].taxRate;
          const realPrice = parseFloat(cartObj.items[index].realPrice);
          const discountAmt = pricingRule.amountDiscount;
          // Exchange lines carry a negative weight; keep the sign so the discount reverses with them.
          const discountUnits = bundleSize === null ? weight : Math.floor(lineQty / bundleSize) * Math.sign(weight);
          const rawTotalDiscount = parseFloat((discountAmt * discountUnits).toFixed(prcPrecision));

          // Discount is subtracted from the tax-inclusive gross (same treatment
          // as TotalBillDiscount.js's FD branch) so a flat "X off" coupon reduces
          // the payable total by exactly X, instead of also shrinking tax on top.
          const taxInclude = (realPrice * taxRate) / 100;
          const gross = (taxIncludeFlag === "Y" ? realPrice : realPrice + taxInclude) * weight;
          // TIC-5459: cap the discount at the line's own gross (mirrors the Math.min guard
          // already used in TotalBillDiscount.js's FD branch) so a misconfigured/oversized
          // flat amountDiscount can't push this line's net negative.
          const totalDiscount = gross >= 0 && rawTotalDiscount > gross ? gross : rawTotalDiscount;
          const netAfterDiscount = gross - totalDiscount;
          const tax = netAfterDiscount - netAfterDiscount / (1 + taxRate / 100);
          const sp = weight !== 0 ? (netAfterDiscount - tax) / weight : 0;

          // Check if any changes are made
          if (
            sp !== cartObj.items[index].salePrice ||
            tax !== cartObj.items[index].taxAmount ||
            netAfterDiscount !== cartObj.items[index].nettotal ||
            totalDiscount !== cartObj.items[index].discount
          ) {
            hasChanges = true;
          }

          cartObj.items[index].salePrice = sp;
          cartObj.items[index].taxAmount = parseFloat(tax.toFixed(prcPrecision));
          cartObj.items[index].nettotal = parseFloat(netAfterDiscount.toFixed(prcPrecision));
          cartObj.items[index].discount = totalDiscount;
          cartObj.items[index].discountName = pricingRule.printedName;
          cartObj.items[index].mPricingruleId = pricingRule.mPricingrulesId;
          cartObj.items[index].nextRule = pricingRule.nextRule;
          cartObj.items[index].iscoupon = iscoupon;
          cartObj.items[index].couponInput = couponInput;
          cartObj.items[index].referenceId = uniqReferenceId;
          cartObj.items[index].priority = pricingRule.priority;
          cartObj.items[index].mPricingCouponId = mPricingCouponId;
          enrichLineItemFields(cartObj.items[index], taxIncludeFlag, prcPrecision);
        } else {
          const mrp = parseFloat(cartObj.items[index].realPrice) * cartObj.items[index].weight;
          const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + cartObj.items[index].taxRate / 100) : (mrp * cartObj.items[index].taxRate) / 100;

          // Check if any changes are made
          if (tax !== cartObj.items[index].taxAmount || mrp !== cartObj.items[index].nettotal || cartObj.items[index].discount !== 0 || cartObj.items[index].discountName !== "") {
            hasChanges = true;
          }

          cartObj.items[index].taxAmount = parseFloat(tax.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          cartObj.items[index].nettotal =
            taxIncludeFlag === "Y"
              ? parseFloat(mrp.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
              : parseFloat((mrp + tax).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
          cartObj.items[index].discount = 0;
          cartObj.items[index].discountName = "";
          cartObj.items[index].mPricingruleId = null;
          delete cartObj.items[index].nextRule;
          enrichLineItemFields(cartObj.items[index], taxIncludeFlag, tillData.tillAccess.csBunit.currencies[0].prcPrecision);
        }
      }
    }

    return item;
  });

  // Check if any changes are made and return the updated cart object
  if (hasChanges) {
    let couponsData = cart.couponInput?.length > 0 ? [...cart.couponInput] : [];
    if (!couponsData.some((coupon) => coupon.couponCode === couponInput) && couponInput !== undefined && couponInput !== null) {
      couponsData.push({ couponCode: couponInput, referenceId: uniqReferenceId, mPricingCouponId: mPricingCouponId, mPricingruleId: mPricingRulesId });
    }
    cartObj.iscoupon = iscoupon;
    cartObj.couponInput = couponsData;
    if (isExchange) {
      useCartStore.getState().setExchangeCart(cartObj);
    } else {
      setCart(cartObj);
    }
    return cartObj;
  }
};
